import { Trans, useTranslation } from 'react-i18next';
import { Unless, When } from 'react-if';

import { Button } from '..';
import { IconLeftIcon } from '../icons';
import { useToolbarService } from './toolbar.service';
import { ToolbarProps } from './toolbar.types';

export const Toolbar: React.FC<ToolbarProps> = ({
  title,
  onBack,
  goBackTo,
  titleKey,
  className,
  rightContent,
  hideBackButton = false,
}: ToolbarProps) => {
  const { t } = useTranslation();
  const { onBackClicked, toolbarClassname } = useToolbarService({
    onBack,
    goBackTo,
    className,
  });

  return (
    <div className={toolbarClassname}>
      <div className="toolbar-statusbar" />
      <div className="toolbar-content">
        <Unless condition={hideBackButton}>
          <Button
            Icon={IconLeftIcon}
            size="small"
            variant="text"
            shape="circle"
            className="rtl-support toolbar-content-button"
            onClick={onBackClicked}
          />
        </Unless>
        <When condition={titleKey !== undefined}>
          <div className="toolbar-content-title">
            <Trans t={t}>{titleKey}</Trans>
          </div>
        </When>
        <When condition={title !== undefined}>
          <div className="toolbar-content-title">{title}</div>
        </When>
        {rightContent}
      </div>
    </div>
  );
};
